import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }

import { reactive, onMounted } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  __name: 'Setting',
  setup(__props) {

const form = reactive({
  store_id:"",
  seller_id:"",
  status:true,
  platform_code:10016,
})
const baseData:any = reactive({
  sellerList:[],
  warehouse_list:[],
  locations_info:[],
})
const handleClick = () => {
  getSellerList()
}
const getSellerList = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.getSellerList({platform_code:form.platform_code}).then((res:any)=>{
      if(res.code==200){
        baseData.sellerList = res.data.list
        if(!form.seller_id){
          form.seller_id = res.data.list[0].store_id
          form.status = res.data.list[0].status ? true : false
        }else{
          form.status = res.data.list.find((item:any)=>item.store_id==form.seller_id).status ? true : false
        }
        get_warehouse_location_list()
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
const get_warehouse_location_list = () => {
  const loading = ElLoading.service({lock: true})
  api.accessoryApi.get_warehouse_location_list({seller_id:form.seller_id}).then((res:any)=>{
    if(res.code==200){
      baseData.locations_info = res.data.locations_info
      baseData.warehouse_list = res.data.warehouse_list
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
const save =  () => { 
  const loading = ElLoading.service({lock: true})
  let status = form.status ? 1 : 0
  api.accessoryApi.save_warehouse_location_list({seller_id:form.seller_id, status:status, locations_info: baseData.locations_info}).then((res:any)=>{
    if(res.code==200){
    
      ElMessage({
        message: res.message,
        type: 'success',
      })
      get_warehouse_location_list()
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}

onMounted(() => {
  getSellerList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("设置")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "180px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: form.seller_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.seller_id) = $event)),
              class: "demo-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.sellerList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: item.store_name,
                    name: item.store_id,
                    key: item.store_id
                  }, null, 8, ["label", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_form_item, { label: "定时同步开关" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.status) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.locations_info, (item) => {
              return (_openBlock(), _createElementBlock("div", { key: item }, [
                _createVNode(_component_el_divider, { "content-position": "left" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name) + "(" + _toDisplayString(item.country_code) + ")", 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, { label: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: item.wids,
                      "onUpdate:modelValue": ($event: any) => ((item.wids) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.warehouse_list, (item1) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: item1.wid,
                            label: item1.wid,
                            value: item1.wid
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item1.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})